import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import { AuthSessionModel } from "../models/soul/AuthSessionModel";
import { SoulAuthModel } from "../models/soul/SoulAuthModel";
import {
  SoulDataModel,
  UpdateSoulInfoPayload,
} from "../models/soul/SoulDataModel";
import { SoulLoginParams } from "../models/soul/SoulLoginParams";

export class SoulApi extends BaseApi {
  private static instance: SoulApi;

  public static get(): SoulApi {
    if (!this.instance) {
      this.instance = new SoulApi();
    }
    return this.instance;
  }

  public soulLogin = BaseApi.createEndpoint<null, SoulLoginParams>(
    HttpMethodEnum.POST,
    "/soul/login"
  );

  public soulInfo = BaseApi.createEndpoint<SoulDataModel, null>(
    HttpMethodEnum.GET,
    "/soul"
  );

  public allSoulsInfo = BaseApi.createEndpoint<SoulDataModel[], null>(
    HttpMethodEnum.GET,
    "/soul/all"
  );

  public updateSoulInfo = BaseApi.createEndpoint<
    SoulDataModel,
    UpdateSoulInfoPayload
  >(HttpMethodEnum.PUT, "/soul");

  public soulAuth = BaseApi.createEndpoint<
    AuthSessionModel | undefined,
    SoulAuthModel
  >(HttpMethodEnum.POST, "/soul/auth");
}

export const soulApi = SoulApi.get();
